import _extends from '@babel/runtime/helpers/esm/extends';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import { fieldStyles } from '@trybeapp/ui.utilities';
import 'prop-types';
import styled, { css } from '@xstyled/styled-components';
import { HtmlInput, HtmlDiv } from '@trybeapp/ui.elements';
import { IconWrapper } from '@trybeapp/ui.field';
import { ClearButton } from '@trybeapp/ui.clear-button';
import { th } from '@xstyled/system';
import { system } from '@trybeapp/ui.system';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledInput = /*#__PURE__*/styled(HtmlInput)(function (_ref) {
  var icon = _ref.icon,
    iconRight = _ref.iconRight,
    isClearable = _ref.isClearable,
    size = _ref.size;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n    ", ";\n\n    ", "\n    ", "\n  "])), system, fieldStyles, icon && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        padding-left: ", ";\n      "])), th("fields.sizes." + size + ".height")), (iconRight || isClearable) && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        padding-right: ", ";\n      "])), th("fields.sizes." + size + ".height")));
});
var Wrapper = /*#__PURE__*/styled(HtmlDiv)(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var isClearable = props.isClearable,
    icon = props.icon,
    iconRight = props.iconRight,
    handleReset = props.handleReset,
    size = props.size,
    value = props.value;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    ref: ref
  })), icon && /*#__PURE__*/React.createElement(IconWrapper, {
    iconPlacement: "left",
    size: size
  }, icon), iconRight && !isClearable && /*#__PURE__*/React.createElement(IconWrapper, {
    iconPlacement: "right",
    size: size
  }, icon), isClearable && value && /*#__PURE__*/React.createElement(IconWrapper, {
    iconPlacement: "right",
    size: size
  }, /*#__PURE__*/React.createElement(ClearButton, {
    onClick: handleReset
  })));
});
Input.defaultProps = {
  type: 'text',
  size: 'lg'
};
Input.displayName = 'Input';

export { Input, StyledInput, Wrapper };
